import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=2619ae2b&scoped=true&"
import script from "./MailList.vue?vue&type=script&lang=js&"
export * from "./MailList.vue?vue&type=script&lang=js&"
import style0 from "./MailList.vue?vue&type=style&index=0&id=2619ae2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2619ae2b",
  null
  
)

export default component.exports